import { useBoolean } from '@dreryk/react-common';

import { DosageInitialEditTemplate, DosageTemplateUse } from '../DosageTemplates.types';

import { DosageTemplatesModal } from './DosageTemplatesModal';

type DosageTemplatesModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type DosageTemplatesModalOpenerProps = {
   readonly children: (renderProps: DosageTemplatesModalOpenerChildrenRenderProps) => JSX.Element;
   readonly defaultTemplate: DosageInitialEditTemplate;
   readonly onUse: DosageTemplateUse;
   readonly shouldConfirmUse: boolean;
};

export const DosageTemplatesModalOpener = (props: DosageTemplatesModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <DosageTemplatesModal
               onClose={closeModal}
               initialEditTemplate={props.defaultTemplate}
               onUse={props.onUse}
               shouldConfirmUse={props.shouldConfirmUse}
            />
         ) : null}
      </>
   );
};
